// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "dff9de748ff26e91c3bd" + ".chunk.js";
};